export default {
  app: {
    featured: 'En vedette',
    random: 'Aléatoire',
    explore: 'Parcourir',
    keywords: 'Mots-Clés',
    search: 'Recherche',
  },
  explore: {
    filters: 'Filtres',
    resetFilters: 'Enlever les filtres',
    addKeyword: 'Ajouter un mot-clés',
  },
  recipe: {
    contributedBy: 'Partagé par',
    ingredients: 'Ingrédients',
    directions: 'Préparation',
    fullRecipe: 'Voir la recette complète:',
    similarDrinks: 'Cocktails similaires',
  },
  featuredRecipes: {
    loadMore: 'Voir plus',
  },
  recipeFind: {
    filterBy: 'Filtrer par',
    name: 'Nom',
    ingredients: 'Ingrédients',
    keywords: 'Mots-clés',
    searchForIngredients:
      'Vous pouvez chercher avec plusieurs ingrédients en les séparants avec un espace',
    searchForKeywords:
      'Vous pouvez chercher avec plusieurs mots-clés en les séparants avec un espace',
  },
  recipeList: {
    viewRecipe: 'Voir la Recette',
  },
  recipeToolbar: {
    print: 'Imprimer',
    share: 'Partager',
    shareOnFacebook: 'Partager sur Facebook',
    shareOnTwitter: 'Partager sur Twitter',
    copyURL: "Copier l'url",
    hideImage: "Cacher l'image",
    setFavorite: 'Ajouter aux favoris',
    unsetFavorite: 'Retirer des favoris',
    urlCopied: 'URL copiée !',
    urlCopiiedInClipboard: "L'URL est copiée dans le presse-papiers",
  },
  keywordList: {
    enterYourKeyword: 'Entrez votre mot-clé',
  },
  favorites: {
    removeAllFavorites: 'Supprimer tous les cocktails favoris',
    noFavoriteDrinks: "Vous n'avez pas de cocktails favoris",
    removeFavoritesPrompt: 'Etes-vous sûr de vouloir supprimer tous les favoris',
    delete: 'Supprimer',
    cancel: 'Annuler',
  },
  search: {
    findYourDrink: 'Rechercher votre cocktail',
  },
  pageNotFound: {
    pageNotFound: 'Page non trouvée',
    backToHome: "Retour à l'accueil",
  },
};
